import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'dibs-elements/exports/Link';
import * as tracking from 'dibs-tracking';

import styles from './SearchBarRecentlyViewedItems.scss';

export const SearchBarRecentlyViewedItemsComponent = props => {
    const [hasFiredImpressions, setHasFiredImpressions] = useState(false);
    const { recentlyViewedItems, isNavigationRefreshVariant } = props;

    const trackClick = (item, index) => {
        tracking.trackEvent({
            category: 'promo interaction',
            action: 'recently viewed - global search items clicked',
            label: 'none',
            value: 0,
        });
        tracking.trackEcommerce({
            type: 'productClick',
            actionField: { list: 'recently viewed - global search', itemId: item.itemId },
            products: [
                {
                    id: item.itemId,
                    dimension83: item.contemporaryTrackingString,
                    position: index + 1,
                    brand: item.dealerPk,
                    list: 'recently viewed - global search',
                },
            ],
        });
    };

    useEffect(() => {
        if (!hasFiredImpressions) {
            tracking.trackEcommerce({
                type: 'productImpression',
                actionField: { list: 'recently viewed - global search' },
                products: recentlyViewedItems.map((item, index) => ({
                    id: item.itemId,
                    dimension83: item.contemporaryTrackingString,
                    position: index + 1,
                    brand: item.dealerPk,
                    list: 'recently viewed - global search',
                })),
            });
            setHasFiredImpressions(true);
        }
    }, [recentlyViewedItems, hasFiredImpressions, setHasFiredImpressions]);

    const itemsClassName = classNames(styles.items, {
        [styles.navigationRefreshItems]: isNavigationRefreshVariant,
    });

    return (
        <div className={itemsClassName}>
            {recentlyViewedItems.map((item, index) => (
                <Link
                    key={item.itemPdpUrl}
                    className={styles.item}
                    href={item.itemPdpUrl}
                    onClick={() => trackClick(item, index)}
                >
                    <img className={styles.image} src={item.itemImageUrl} alt={item.itemTitle} />
                </Link>
            ))}
        </div>
    );
};

SearchBarRecentlyViewedItemsComponent.propTypes = {
    recentlyViewedItems: PropTypes.array,
    isNavigationRefreshVariant: PropTypes.bool,
};

const mapStateToProps = ({ header }) => {
    const { isNavigationRefreshVariant } = header;
    return {
        isNavigationRefreshVariant,
    };
};

export const SearchBarRecentlyViewedItems = connect(mapStateToProps)(
    SearchBarRecentlyViewedItemsComponent
);
